import AchievementTag from 'models/tag/AchievementTag';

import TagBaseService from 'services/tag/TagBaseService';

export default class AchievementTagService extends TagBaseService {
	toModel(tag) {
		return new AchievementTag(tag);
	}
}
